// Single source of truth for the customer language choice (P1 LanguageSwitcher writes this key).
export const getCurrentLang = () => {
  try {
    return localStorage.getItem("izzygo_lang") || "en";
  } catch {
    return "en";
  }
};

// Append ?lang / &lang to a URL. English is the base column, so no param is sent for 'en'.
export const withLang = (url) => {
  const lang = getCurrentLang();
  if (!lang || lang === "en") return url;
  if (/[?&]lang=/.test(url)) return url; // already wired by the caller — don't double-append
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}lang=${encodeURIComponent(lang)}`;
};
